import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getAllRoleFeatures } from "../../redux/features/login/login";
import Loader from "../../components/Loader/Index";
import ICONS from "../../assets/Icons";

const FeatureNotAssigned = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [features, setFeatures] = useState([]);
  const { unavailableService } = location.state || {};
  const [adminLoading, setAdminLoading] = useState(false);
  const { roleFeatures } = useSelector((state) => state.login);
  const refreshData = useSelector((state) => state.refreshToken.data);

  useEffect(() => {
    if (Array.isArray(unavailableService)) {
      setFeatures(unavailableService);
    } else if (typeof unavailableService === "string") {
      setFeatures(unavailableService.split(",").map((item) => item.trim()));
    }
  }, [unavailableService]);

  useEffect(() => {
    setAdminLoading(true);

    dispatch(getAllRoleFeatures()).then(() => setAdminLoading(false));
  }, [dispatch]);

  return (
    <>
      <div id="webviewd">
        <div className="flex w-full h-screen">
          <div className="max-w-max-content-width w-full mx-auto flex">
            <div className="w-field-force-width flex flex-col justify-center items-center text-center">
              <div className="mt-timeline-top">
                <img
                  src={ICONS?.FEATURE_NOT_ASSIGNED}
                  alt=""
                  className="h-graphic-square-height-md mb-margin-md"
                />
              </div>
              <h3 className="text-xl text-text-primary font-semibold mt-margin-lg">
                Feature not assigned
              </h3>
              <p className="text-text-primary text-sm mt-margin-sm">
                The services required for this feature <br /> are not assigned
                to your user.
              </p>
              <div
                className="mt-margin-lg"
                onClick={() => navigate("/home")}
              >
                <button className="text-Primary-black bg-text-primary w-auto rounded-border-radius-md px-padding-xl py-padding-button-m text-lg font-semibold">
                  Home
                </button>
              </div>
            </div>

            <div className="w-tl-width-3 flex justify-center items-center pt-medium-screen-top-padding">
              <div className="bg-custom-blue w-full h-auto p-padding-md pr-padding-base rounded-border-radius-md">
                <div className="pr-padding-md">
                  <h3 className="mb-margin-md text-xl text-text-primary font-semibold">
                    To resolve this issue -
                  </h3>
                  <p className="mb-margin-md text-sm text-text-secondary font-normal">
                    Contact your admin and request them to assign the feature
                    required to your User ID:
                    <i className="font-bold text-text-primary">
                      &nbsp;{refreshData?.employees?.user_id}
                    </i>
                  </p>
                  <span className="text-xs text-text-secondary">
                    Feature must include the following services -
                  </span>
                  <div className="mt-margin-sm w-full mb-margin-md">
                    <ul className="list-disc list-outside grid grid-cols-2 gap-gap-button-m pl-padding-button-m">
                      {features.map((item, index) => (
                        <li
                          key={index}
                          className="text-text-primary text-font-md italic ml-margin-md"
                        >
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <hr className="text-text-secondary mr-margin-xl" />

                <div className="mt-margin-md">
                  <p className="text-xs text-text-secondary">
                    Users with admin rights -
                  </p>
                  <div className="mt-margin-sm w-full max-h-graphic-rectangle-height-md overflow-y-auto">
                    {adminLoading ? (
                      <div className="h-loader-sm flex items-center">
                        <div className="scale-[0.6]">
                          <Loader />
                        </div>
                      </div>
                    ) : roleFeatures?.employees?.length ? (
                      <ul className="list-disc list-outside grid grid-cols-2 gap-gap-button-m pl-padding-button-m">
                        {roleFeatures.employees.map((employee, index) => (
                          <li
                            key={index}
                            className="text-text-primary ml-margin-md text-font-md italic"
                          >
                            {employee.first_name} {employee.last_name}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <div className="text-text-secondary mt-margin-sm text-xs">
                        No data found
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="mobileviewd">
        <div className="flex w-full">
          <div className="w-full mx-auto">
            <div className="w-full justify-center items-center text-center">
              <div className="mt-margin-xl">
                <img
                  src={ICONS?.FEATURE_NOT_ASSIGNED}
                  alt="NotAssigned"
                  className="h-graphic-square-height-md mb-margin-md w-width-xl mx-auto"
                />
              </div>
              <h3 className="text-xl text-text-primary font-semibold mt-margin-lg">
                Feature not assigned
              </h3>
              <p className="text-text-primary text-sm mt-margin-sm">
                The services required for this feature <br /> are not assigned
                to your user.
              </p>
            </div>

            <div className="w-full justify-center items-center mt-margin-lg">
              <div className="bg-custom-blue w-full min-h-[50vh] h-auto p-padding-md pr-padding-base rounded-t-border-radius-md">
                <div className="pr-padding-md">
                  <h3 className="mb-margin-md text-xl text-text-primary font-semibold">
                    To resolve this issue -
                  </h3>
                  <p className="mb-margin-md text-sm text-text-secondary font-normal pr-padding-xl">
                    Contact your admin and request them to assign the feature
                    required to your User ID:
                    <i className="font-bold text-text-primary">
                      &nbsp;{refreshData?.employees?.user_id}
                    </i>
                  </p>
                  <span className="text-xs text-text-secondary">
                    Feature must include the following services -
                  </span>
                  <div className="mt-margin-sm w-full">
                    <ul className="list-disc list-outside ml-margin-md">
                      {features.map((item, index) => (
                        <li
                          key={index}
                          className="italic text-text-primary text-base pb-padding-sm"
                        >
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <hr className="text-text-secondary mr-margin-md" />

                <div className="mt-margin-md ">
                  <p className="text-xs text-text-secondary">
                    Users with admin rights -
                  </p>
                  <div className="mt-margin-sm w-full max-h-graphic-rectangle-height-md overflow-y-auto">
                    {adminLoading ? (
                      <div className="h-loader-sm flex items-center">
                        <div className="scale-[0.6]">
                          <Loader />
                        </div>
                      </div>
                    ) : roleFeatures?.employees?.length ? (
                      <ul className="list-disc list-outside grid grid-cols-2 gap-gap-button-m pl-padding-button-m">
                        {roleFeatures.employees.map((employee, index) => (
                          <li
                            key={index}
                            className="text-text-primary text-font-md italic ml-margin-md"
                          >
                            {employee.first_name} {employee.last_name}
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <div className="text-text-secondary mt-margin-sm text-xs">
                        No data found
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div
              className="w-full mt-margin-xl justify-center items-center"
              onClick={() => navigate("/home")}
            >
              <button className="text-Primary-black bg-text-primary w-full px-padding-xl py-padding-sm fixed bottom-bottom-base">
                Home
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FeatureNotAssigned;
